module.exports = __webpack_public_path__ + "assets/src/style/img/footer-parkmanagement.png?872dc1161fff37512fa3f8582e3ff407";